/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio DSM-5 Diagnoses API
 * API for searching DSM-5 diagnoses from the official NZa codelist. This is reference data used for structured diagnosis selection on care trajectories. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * DSM-5 diagnosis from the official NZa codelist
 */
export interface Dsm5DiagnosisDto {
    /**
     * Unique identifier
     */
    'id': string;
    /**
     * DSM-5 diagnosis code (e.g., \"D5_1.01.01\")
     */
    'code': string;
    /**
     * Full description of the diagnosis
     */
    'description': string;
    /**
     * ICD-10 code for GDS801 billing compatibility
     */
    'icd10Code'?: string | null;
    /**
     * Numeric DSM / ICD-9-CM code (e.g. \"309.24\") — the code clinicians recognise. Searchable alongside the D5_ code and description. 
     */
    'icd9cmCode'?: string | null;
    /**
     * DSM-5 code of the parent group in the hierarchy (null for top-level chapters). Used to build a collapsible tree. 
     */
    'parentCode'?: string | null;
    /**
     * Hierarchy level (1 = chapter, deeper = more specific).
     */
    'niveau'?: number | null;
    /**
     * Whether this row is a selectable leaf diagnosis. Non-selectable rows are group/parent nodes that exist only to build the tree. 
     */
    'selectable': boolean;
}
/**
 * RFC 7807 Problem Details for HTTP APIs
 */
export interface ProblemDetail {
    /**
     * URI reference identifying the problem type
     */
    'type': string;
    /**
     * Short, human-readable summary
     */
    'title': string;
    /**
     * HTTP status code
     */
    'status': number;
    /**
     * Human-readable explanation
     */
    'detail'?: string;
    /**
     * URI reference identifying the specific occurrence
     */
    'instance'?: string;
    /**
     * List of validation errors
     */
    'errors'?: Array<ProblemDetailErrorsInner>;
}
export interface ProblemDetailErrorsInner {
    /**
     * Field name that failed validation
     */
    'field'?: string;
    /**
     * Error message
     */
    'message'?: string;
}

/**
 * Dsm5DiagnosesApi - axios parameter creator
 */
export const Dsm5DiagnosesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the complete DSM-5 codelist in a single call, including the non-selectable group/parent rows, so the client can build a collapsible hierarchy tree and perform search/filtering locally.  The dataset is small and static reference data (~860 rows), so the client fetches it once and caches it. Unlike the paginated search endpoint this returns every row (selectable and group rows alike), ordered by code. 
         * @summary List the full enriched DSM-5 codelist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllDsm5Diagnoses: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dsm5-diagnoses/all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json,application/problem+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Search the official NZa DSM-5 diagnosis codelist. Returns diagnoses matching the search term in code or description. Results are ordered by code. 
         * @summary Search DSM-5 diagnoses
         * @param {string} [search] Search term to match against code or description (case-insensitive, partial match)
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDsm5Diagnoses: async (search?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/dsm5-diagnoses`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication firebaseAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json,application/problem+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * Dsm5DiagnosesApi - functional programming interface
 */
export const Dsm5DiagnosesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = Dsm5DiagnosesApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the complete DSM-5 codelist in a single call, including the non-selectable group/parent rows, so the client can build a collapsible hierarchy tree and perform search/filtering locally.  The dataset is small and static reference data (~860 rows), so the client fetches it once and caches it. Unlike the paginated search endpoint this returns every row (selectable and group rows alike), ordered by code. 
         * @summary List the full enriched DSM-5 codelist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllDsm5Diagnoses(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dsm5DiagnosisDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllDsm5Diagnoses(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Dsm5DiagnosesApi.listAllDsm5Diagnoses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Search the official NZa DSM-5 diagnosis codelist. Returns diagnoses matching the search term in code or description. Results are ordered by code. 
         * @summary Search DSM-5 diagnoses
         * @param {string} [search] Search term to match against code or description (case-insensitive, partial match)
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchDsm5Diagnoses(search?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Dsm5DiagnosisDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchDsm5Diagnoses(search, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['Dsm5DiagnosesApi.searchDsm5Diagnoses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * Dsm5DiagnosesApi - factory interface
 */
export const Dsm5DiagnosesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = Dsm5DiagnosesApiFp(configuration)
    return {
        /**
         * Returns the complete DSM-5 codelist in a single call, including the non-selectable group/parent rows, so the client can build a collapsible hierarchy tree and perform search/filtering locally.  The dataset is small and static reference data (~860 rows), so the client fetches it once and caches it. Unlike the paginated search endpoint this returns every row (selectable and group rows alike), ordered by code. 
         * @summary List the full enriched DSM-5 codelist
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllDsm5Diagnoses(options?: RawAxiosRequestConfig): AxiosPromise<Array<Dsm5DiagnosisDto>> {
            return localVarFp.listAllDsm5Diagnoses(options).then((request) => request(axios, basePath));
        },
        /**
         * Search the official NZa DSM-5 diagnosis codelist. Returns diagnoses matching the search term in code or description. Results are ordered by code. 
         * @summary Search DSM-5 diagnoses
         * @param {string} [search] Search term to match against code or description (case-insensitive, partial match)
         * @param {number} [limit] Maximum number of results to return
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDsm5Diagnoses(search?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Dsm5DiagnosisDto>> {
            return localVarFp.searchDsm5Diagnoses(search, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Dsm5DiagnosesApi - object-oriented interface
 */
export class Dsm5DiagnosesApi extends BaseAPI {
    /**
     * Returns the complete DSM-5 codelist in a single call, including the non-selectable group/parent rows, so the client can build a collapsible hierarchy tree and perform search/filtering locally.  The dataset is small and static reference data (~860 rows), so the client fetches it once and caches it. Unlike the paginated search endpoint this returns every row (selectable and group rows alike), ordered by code. 
     * @summary List the full enriched DSM-5 codelist
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAllDsm5Diagnoses(options?: RawAxiosRequestConfig) {
        return Dsm5DiagnosesApiFp(this.configuration).listAllDsm5Diagnoses(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Search the official NZa DSM-5 diagnosis codelist. Returns diagnoses matching the search term in code or description. Results are ordered by code. 
     * @summary Search DSM-5 diagnoses
     * @param {string} [search] Search term to match against code or description (case-insensitive, partial match)
     * @param {number} [limit] Maximum number of results to return
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchDsm5Diagnoses(search?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return Dsm5DiagnosesApiFp(this.configuration).searchDsm5Diagnoses(search, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



